import React from 'react';
import clsx from 'clsx';
import styles from './Radio.module.scss';

type Props = {
  name?: string;
  value?: string;
  className?: string;
  children?: React.ReactNode;
  defaultChecked?: boolean;
  disabled?: boolean;
  onChange?: any;
  type?: string;
  id?: string;
};

const Radio = React.forwardRef<HTMLInputElement, Props>((props, ref): JSX.Element => {
  const {
    name,
    value,
    className,
    children,
    defaultChecked,
    disabled,
    onChange,
    type = "radio",
    id,
    ...other
  } = props;

  return (
    <label className={clsx(styles.container, className)}>
      <input
        id={id}
        ref={ref}
        type={type}
        name={name}
        value={value}
        className={styles.input}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        {...other}
      />
      <span className={styles.label}>{children}</span>
    </label>
  );
});

export default React.memo(Radio);